import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { AppProfileService } from '../services/profile.service';

@Injectable({
  providedIn: 'root',
})
export class ShopAccessGuard {
  private profileService = inject(AppProfileService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.profileService.currentProfile$.pipe(
      switchMap((p) => {
        return of(p != null && p.hasShopAccess);
      })
    );
  }
}
